import SVGSave from '../svg/svg-save';

export default class RazeniSave {
  static getData(target) {
    const sortableId = target.id;
    const $items = target.querySelectorAll('[data-sortable-item]');

    // Get sortable type (horizontal/vertical)
    const sortableType = target.getAttribute('data-sortable-target');

    // Store items with full metadata
    const items = Array.from($items).map(($item, currentPosition) => {
      const originalIndex = parseInt($item.dataset.sortableIndex, 10);
      const itemId = $item.id;
      const dragType = $item.getAttribute('data-sortable-drag');
      const correctAnswer = $item.getAttribute('data-sortable-spravnaodpoved');

      const itemData = {
        id: itemId,
        currentPosition,
        originalIndex,
        correctIndex: correctAnswer ? parseInt(correctAnswer, 10) - 1 : null,
        medium: dragType,
      };

      // Extract caption/popisek if exists
      const $caption = $item.querySelector('.caption-on-hover-text');
      if ($caption) {
        itemData.caption = $caption.textContent.trim();
      }

      // Extract content based on medium type
      switch (dragType) {
        case 'svg': {
          const $svg = $item.querySelector('svg[data-svg-target]');
          if ($svg) {
            const svgData = SVGSave.getData($svg);
            itemData.svg = {
              id: $svg.id || null,
              node: 'svg',
              viewBox: svgData.viewBox,
              value: {
                paths: svgData.paths,
                circles: svgData.circles,
                draggings: svgData.draggings,
                textareas: svgData.textareas,
                comics: svgData.comics,
              },
            };
          }
          break;
        }
        case 'text': {
          const $text = $item.querySelector('.sortable-item-text p');
          if ($text) {
            itemData.text = $text.textContent.trim();
          }
          break;
        }
        case 'obrazek': {
          const $img = $item.querySelector('img');
          if ($img) {
            itemData.imageSrc = $img.getAttribute('src');
            itemData.imageAlt = $img.getAttribute('alt') || '';
          }
          break;
        }
        case 'audio': {
          const $audio = $item.querySelector('audio');
          if ($audio) {
            itemData.audioSrc = $audio.getAttribute('src');
          }
          const $title = $item.querySelector('.media-player-title');
          if ($title) {
            itemData.audioTitle = $title.textContent.trim();
          }
          const $label = $item.querySelector('.media-player-label');
          if ($label) {
            itemData.audioLabel = $label.textContent.trim();
          }
          const $description = $item.querySelector('.media-player-description');
          if ($description) {
            itemData.audioDescription = $description.textContent.trim();
          }
          // Detect audio player design type
          const $player = $item.querySelector('[data-player-audio]');
          if ($player) {
            itemData.audioDesign = $player.getAttribute('data-player-audio');
          }
          break;
        }
        case 'video': {
          const $video = $item.querySelector('video source');
          if ($video) {
            itemData.videoSrc = $video.getAttribute('src');
          }
          const $title = $item.querySelector('.media-player-title');
          if ($title) {
            itemData.videoTitle = $title.textContent.trim();
          }
          const $label = $item.querySelector('.media-player-label');
          if ($label) {
            itemData.videoLabel = $label.textContent.trim();
          }
          const $description = $item.querySelector('.media-player-description');
          if ($description) {
            itemData.videoDescription = $description.textContent.trim();
          }
          break;
        }
        default:
          break;
      }

      return itemData;
    });

    return {
      id: sortableId,
      type: sortableType,
      items,
    };
  }

  static loadData(target, data) {
    if (!data || !data.items) return;

    const $items = Array.from(target.querySelectorAll('[data-sortable-item]'));
    const $container = target;

    // Create a map of item ID to element for quick lookup
    const itemsMap = new Map();
    $items.forEach(($item) => {
      itemsMap.set($item.id, $item);
    });

    // Sort items by currentPosition
    const sortedItems = [...data.items].sort(
      (a, b) => a.currentPosition - b.currentPosition,
    );

    // Reorder DOM elements according to saved state
    sortedItems.forEach((itemData) => {
      const $item = itemsMap.get(itemData.id);
      if ($item) {
        // appendChild automatically moves the element if it already exists
        $container.appendChild($item);

        // Restore SVG data if present
        if (itemData.medium === 'svg' && itemData.svg) {
          const $svg = $item.querySelector('svg[data-svg-target]');
          if ($svg) {
            SVGSave.loadData($svg, itemData.svg.value);
          }
        }
      }
    });

    // Keep linked SVG modules (data-sortable-inheritor) in sync in read-only mode.
    const $inheritors = document.querySelectorAll(
      `[data-sortable-inheritor="${target.id}"]`,
    );

    if ($inheritors.length > 0) {
      $inheritors.forEach(($inheritor) => {
        const $firstInheritorItem = $inheritor.querySelector(
          '[data-sortable-inheritor-item]',
        );

        if (!$firstInheritorItem) return;

        const $inheritorContainer = $firstInheritorItem.parentElement;
        sortedItems.forEach((itemData) => {
          const $inheritorItem = $inheritorContainer.querySelector(
            `[data-sortable-inheritor-item="${itemData.originalIndex}"]`,
          );

          if ($inheritorItem) {
            $inheritorContainer.appendChild($inheritorItem);
          }
        });
      });
    }
  }
}
